<!--先进企业 申报填写-->
<template>
   <div>
      <div class="headView">
         <p class="applyTitle">项目名称：{{this.form.project_name}}</p>
         <div class="headClass">
            <p>项目类型：科技成果奖</p>
            <p>申请时间：{{ this.form.applyDateRange }}</p>
            <p>审核时间：{{ this.form.auditDateRange }}</p>
         </div>
      </div>
      <div class="content_view">
         <!--左侧Tab切换-->
         <div class="contentLeft">
            <p v-for="(item,index) in navList" :key="index" @click="changeIndex(index)"
               :class="navIndex === index?'tabActive':''">
               {{ item }}
            </p>
         </div>
         <!--右侧内容界面,通过navIndex切换显示-->
         <div class="contentRight">
            <div v-show="navIndex == 0">
               <p class="view_head">
                  申报须知
               </p>
               <div style="height: 500px;overflow-y: scroll">
                  <pdf-vue v-if="this.form.require_pdf_url" :pdf_url="this.form.require_pdf_url"></pdf-vue>
               </div>
               <div class="uploadBtn" v-if="isShowOne" style="margin-top: 5px; margin-bottom: 5px;">
                  <el-button type="primary" @click="_ReadOne">我已阅读</el-button>
               </div>
            </div>
            <div v-show="navIndex == 1">
               <p class="view_head">
                  评选办法
               </p>
               <div style="height: 500px;overflow-y: scroll">
                  <pdf-vue v-if="this.form.selection_pdf_url" :pdf_url="this.form.selection_pdf_url"></pdf-vue>
               </div>
               <div class="uploadBtn" v-if="isShowTwo" style="margin-top: 5px; margin-bottom: 5px;">
                  <el-button type="primary" @click="_ReadTwo">我已阅读</el-button>
               </div>
            </div>
            <div v-show="navIndex == 2">
               <p class="view_head">基本信息</p>
               <apply_basic ref="applyBasic"></apply_basic>
            </div>
            <div class="" v-show="navIndex == 3">
               <p class="view_head">资料上传</p>
               <apply_attach ref="applyAttach"></apply_attach>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
   import apply_basic from "@/views/techAchieveApply/components/apply_basic";
   import apply_attach from "@/views/techAchieveApply/components/apply_attach";
   import pdfVue from '@/components/pdfVue.vue'
   import ruiTool from "@/utils/ruiTool";
   import ruiDate from "@/utils/ruiDate";
   import {getPrjInfoByApplyId, getPrjInfoByCode} from "@/api/modules/project";

   export default {
      data() {
         return {
            navIndex: 0,
            spanWidth: '180px',
            navList: ["申报须知",
               "评选办法",
               "基本信息",
               "资料上传"
            ],
            form: {
               project_application_id: '',
               project_code: '',
               project_name: '',
               //申请时间
               applyDateRange: '',
               //审核时间
               auditDateRange: '',
               //申报须知
               require_pdf_url: '',
               //评选办法
               selection_pdf_url: '',
               isReadOne: false,
               isReadTwo: false
            }
         }
      },
      components: {
         apply_basic,
         apply_attach,
         pdfVue
      },
      async created() {
         /*项目类型,19:科技成果*/
         localStorage.setItem('projectType', "19");
         //获取传入的参数,并保存
         this.form.project_application_id = ruiTool.getUrlPara(window.location.href, 'prjApplyCode');
         this.form.project_code = ruiTool.getUrlPara(window.location.href, 'prjCode');
         localStorage.setItem("prjApplyCode", this.form.project_application_id);
         localStorage.setItem("prjCode", this.form.project_code);

         //两个参数都未传入，则跳转回列表页面
         if (ruiTool.isNull(this.form.project_application_id) && ruiTool.isNull(this.form.project_code)) {
            console.info("----返回列表")
            this.$router.push("/index/techAchieveApply/projectList")
         }

         //获取项目的申报须知和评选条件
         if (ruiTool.isNotNull(this.form.project_code)) {
            //申请模式，清楚项目申请编号
            localStorage.removeItem("prjApplyCode");
            localStorage.setItem("opMode", "edit");
            //是否新增
            localStorage.setItem("isInsert", "true")

            //通过项目编号获取数据
            const param = {project_code: this.form.project_code}
            getPrjInfoByCode({
               data: param,
               success: (res) => {
                  this.form.project_name = res.data.item.project_name;
                  this.form.require_pdf_url = res.data.item.require_pdf_url;
                  this.form.selection_pdf_url = res.data.item.selection_pdf_url;
                  this.form.applyDateRange = ruiDate.toRangeDate(res.data.item.apply_start, res.data.item.apply_end);
                  this.form.auditDateRange = ruiDate.toRangeDate(res.data.item.app_start, res.data.item.app_end);

                  console.log(this.form);
               }
            })
         } else {
            //通过项目申请编号获取信息
            const param = {prjApplyId: this.form.project_application_id};
            getPrjInfoByApplyId({
               data: param,
               success: (res) => {
                  this.form.project_code = res.data.item.project_code;
                  const param = {project_code: this.form.project_code}
                  getPrjInfoByCode({
                     data: param,
                     success: (res) => {
                        this.form.project_name = res.data.item.project_name;
                        this.form.require_pdf_url = res.data.item.require_pdf_url;
                        this.form.selection_pdf_url = res.data.item.selection_pdf_url;
                        this.form.applyDateRange = ruiDate.toRangeDate(res.data.item.apply_start, res.data.item.apply_end);
                        this.form.auditDateRange = ruiDate.toRangeDate(res.data.item.app_start, res.data.item.app_end);
                     }
                  })
               }
            })
         }
      },
      computed:{
         isShowOne() {
            if (localStorage.getItem("isInsert") == "true" && this.form.isReadOne == false)
               return true;
            return false;
         },
         isShowTwo() {
            if (localStorage.getItem("isInsert") == "true" && this.form.isReadTwo == false)
               return true;
            return false;
         }
      },
      methods: {
         changeIndex(index) {
            if (localStorage.getItem("isInsert") == "true") {
               if (index >= 1 && this.form.isReadOne == false) {
                  this.$msgbox.alert("请点击申报须知的已阅")
                  return;
               }
               if (index >= 2 && this.form.isReadTwo == false) {
                  this.$msgbox.alert("请点击评选办法的已阅")
                  return;
               }
            }
            this.navIndex = index;
         },
         _ReadOne() {
            this.form.isReadOne = true;
         },
         _ReadTwo() {
            this.form.isReadTwo = true;
         }
      }
   }
</script>

<style scoped>

   .uploadHead p {
      margin-left: 10px;
      color: #1890FF;
      cursor: pointer;
   }


   .head_list p {
      margin-left: 10px;
   }

   .head_list p:hover {
      color: #1890FF;
      text-decoration: underline;
   }

   .view_head {
      font-size: 18px;
      font-weight: 600;
      margin-top: 20px;
   }

   .headView {
      display: flex;
      flex-flow: column;
      align-items: flex-start;
   }

   .applyTitle {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #000000;
   }

   .headClass {
      display: flex;
      margin-top: 10px;
   }

   .headClass p {
      margin-right: 40px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
   }

   /* 申报 */
   .content_view {
      margin: 20px;
      width: 100%;
      min-height: 350px;
      display: flex;
      border: 1px solid #f0f0f0;
   }

   .contentLeft {
      width: 200px;
   }

   .contentLeft p {
      height: 50px;
      line-height: 50px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      color: #333333;
      background-color: #fafafa;
      cursor: pointer;
   }

   .contentRight {
      width: 100%;
   }

   .tabActive {
      background: #e6f7ff !important;
      color: #6ea7ff !important;
      border-right: 2px solid #0077ff;
   }

   .content_btn {
      display: flex;
      flex-flow: column;
      align-items: flex-start;
      margin-top: 20px;
      margin-left: 180px;
   }

   .content_btn p {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FE2C54;
   }

   .content_btn button {
      width: 150px;
      margin-top: 40px;
      margin-left: 440px;
   }

   .specialView {
      width: 720px;
      display: flex;
      align-items: center;
   }

   .specialView input {
      margin-left: 20px;
      width: 100%;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      letter-spacing: 1px;
      border-bottom: 1px solid #DBDBDB;
   }

   .specialView input::placeholder {
      color: #B5B5B5;
   }
</style>
